import { FC } from 'react'

import './post-seo-preview.styles.css'
import { Image } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

export const TwitterSEOCard: FC<{
  title: string
  description: string
  thumbnailUrl?: string
  type?: 'summary_large_image' | 'summary'
}> = ({ thumbnailUrl, title, description, type = 'summary_large_image' }) => {
  const { data: network } = useNetwork()
  const { domain, logo, favicon } = network || {}
  const logoUrl = (logo as Image)?.url
  const faviconUrl = (favicon as Image)?.url
  const _thumbnailUrl = thumbnailUrl || logoUrl || faviconUrl

  let forceType = type
  if (_thumbnailUrl === logoUrl || _thumbnailUrl === faviconUrl) {
    forceType = 'summary'
  }

  if (forceType === 'summary' || !_thumbnailUrl) {
    return (
      <div className="TwitterCardsGrid TwitterCard TwitterCard--animation">
        <div className="TwitterCardsGrid-col--12 TwitterCardsGrid-col--spacerBottom CardContent">
          <div className="SummaryCard--small TwitterCard-container u-block">
            <div
              className="SummaryCard-image TwitterCardsGrid-float--prev"
              style={{
                backgroundSize: 'cover',
                backgroundImage: `url(${_thumbnailUrl})`,
              }}
            >
              {!_thumbnailUrl && (
                <div className="tcu-imageContainer tcu-imageAspect--1to1">
                  <div className="tcu-imageWrapper"></div>
                </div>
              )}
            </div>
            <div className="SummaryCard-contentContainer TwitterCardsGrid-float--prev">
              <div className="SummaryCard-content TwitterCardsGrid-ltr">
                <h2
                  className="TwitterCard-title js-cardClick tcu-textEllipse--multiline"
                  dir="ltr"
                >
                  {title}
                </h2>

                <p
                  className="tcu-resetMargin u-block TwitterCardsGrid-col--spacerTop tcu-textEllipse--multiline"
                  dir="ltr"
                >
                  {description}
                </p>

                <span
                  className="u-block TwitterCardsGrid-col--spacerTop SummaryCard-destination"
                  dir="ltr"
                >
                  {domain}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="card-seo-twitter">
      <div
        className="card-seo-twitter__image"
        style={{ backgroundImage: `url(${_thumbnailUrl})` }}
      ></div>
      <div className="card-seo-twitter__text">
        <span className="card-seo-twitter__title">{title}</span>
        <span className="card-seo-twitter__description">{description}</span>
        <span className="card-seo-twitter__link">{domain}</span>
      </div>
    </div>
  )
}
